import React from "react";

const mutedStyle = { color: "#9e9e9e" };
const failedStyle = { color: "#c00", fontWeight: 600 };
const pinStyle = { fontSize: 18, letterSpacing: 3, fontWeight: "bold" };

/*
 * The API already withholds the digits once a PIN is revoked or past its
 * window; expiry is still worked out here so the row reads "Expired" rather
 * than a bare status.
 */
export function walkupPinStatus(pinpadAccess, now = new Date()) {
  if (!pinpadAccess) return null;
  if (pinpadAccess.status === "revoked") return "revoked";
  if (pinpadAccess.validTo && new Date(pinpadAccess.validTo) <= now) return "expired";
  return pinpadAccess.status;
}

function WalkupPinLabel({ status, pin }) {
  switch (status) {
    case "pending":
      return <span style={mutedStyle}>Generating…</span>;
    case "failed":
      return <span style={failedStyle}>PIN failed – use assisted access</span>;
    case "revoked":
      return <span style={mutedStyle}>Revoked</span>;
    case "expired":
      return <span style={mutedStyle}>Expired</span>;
    default:
      return pin ? <span style={pinStyle}>{pin}</span> : <span style={mutedStyle}>PIN issued</span>;
  }
}

function stopRowClick(event) {
  event.stopPropagation();
}

export default function WalkupPinCell({ pinpadAccess, style }) {
  const status = walkupPinStatus(pinpadAccess);

  return (
    <td style={style} onClick={status ? stopRowClick : undefined}>
      {status ? <WalkupPinLabel status={status} pin={pinpadAccess.pin} /> : null}
    </td>
  );
}
